import localForageDataProvider from 'ra-data-local-forage';
import type { DataProvider } from 'react-admin';
import { seedData } from './seed';

// Async factory: ra-data-local-forage hydrates from IndexedDB (via localForage).
// defaultData seeds ONLY on first run (when storage is empty).
let cached: DataProvider | null = null;

export async function buildDataProvider(): Promise<DataProvider> {
  if (cached) return cached;
  cached = await localForageDataProvider({
    defaultData: seedData,
    prefixLocalForageKey: 'ai-cong-no-',
    loggingEnabled: false,
  });
  return cached;
}
